export default {
    layoutSelector: 'Layout',
    TopBarLeft: 'Oben Links',
    TopBarRight: 'Oben Rechts',
    BottomBarLeft: 'Unten Links',
    BottomBarRight: 'Unten Rechts',
    SidebarRight: 'Rechts',
    SidebarLeft: 'Links',
    TopBar: 'Oben',
    BottomBar: 'Unten',
    createLocalPanel: 'Lokales Panel erstellen',
    createGlobalPanel: 'Globales Panel erstellen',
    layoutPosition: 'Layout-Position',
    noLayoutPosition: 'Keine (freie Position)',
    noMarginBottom: 'Kein Abstand nach unten',
    fontAutoSize: 'Auto size font based on screen resolution',
    invalidEmailFormat: 'Ungültiges E-Mail-Format',
    sendScreenshot: 'Screenshot senden',
    selectedTemplate: 'Ausgewähltes Template',
    createNew: 'Neues Template erstellen',
    selectExisting: 'Vorhandenes Template auswählen',
    templateName: 'Template Name',
    setUserIdAsReplyTo: 'Benutze User-Login als Reply-To Email-Adresse bei der verschickten E-Mail',
    LoginBlockEmailAdressHint: 'Stellen Sie sicher, dass beim Login-Block die Option angewählt ist, nur E-Mails als Input zuzulassen.',
    invalidEmailAddress: 'Ungültige E-Mail-Adresse',
    OrSelectByStepName: 'Oder wähle den Schritt-Namen',
    SelectByStepId: 'Wähle die Schritt-ID',
    partInfoHint: 'Wenn im vSTAGE auf ein Bauteil geklickt wird, werden die Informationen aus den unten ausgewählten Feldern angezeigt.',
    navigation: 'Navigation',
    navigationSettingsInfo: 'Es werden nur Projekte angezeigt, auf die der User Zugriff hat. Bei veröffentlichten Projekten wird die Verlinkung weiter auf private Projekte zeigen. Projekte ohne eine vForm werden nicht angezeigt.',
    stepNavigation: 'Schritt-Navigation',
    stepNavigationSettingsInfo: 'Erstellt für jeden Schritt dieses Formulars einen Button (sortiert nach Schritt-Reihenfolge). Der aktuelle Schritt wird mit den unten eingestellten Aktiv-Farben hervorgehoben.',
    buttonColor: 'Button-Textfarbe',
    buttonBackgroundColor: 'Button-Hintergrundfarbe',
    activeButtonColor: 'Aktiver Button – Textfarbe',
    activeButtonBackgroundColor: 'Aktiver Button – Hintergrundfarbe',
    noStepsFound: 'Keine Schritte gefunden',
    step: 'Schritt',
    notApplicableInBar: 'n/a in Leiste',
    TextAlignment: 'Textausrichtung',
    backgroundColor: 'Hintergrundfarbe',
    borderColor: 'Rahmenfarbe',
    fontColor: 'Schriftfarbe',
    maximumLimitIs: 'Das Maximum ist {limit}',
    minimumLimitIs: 'Das Minimum ist {limit}',
    sort: 'Sortierung',
    filter: 'Filter',
    limit: 'Limit',
    noProjectsFound: 'Keine Projekte gefunden',
    itemsFound: 'Einträge gefunden',
    currentProjectExcluded: 'Das aktuelle Projekt wird nicht angezeigt',
    savingFormFailed: 'Speichern des vForms fehlgeschlagen. Mögliche Ursache können ungültige Sonderzeichen im Text sein.',
    saveAnyway: 'Trotzdem speichern',
    formOutdatedAlert: 'Es gibt eine neuere Version dieses Formulars, die von {lastSavedBy} am {updatedAt} gespeichert wurde. Wenn Sie fortfahren, werden diese Änderungen überschrieben.',
    formSavingFailedAlert: 'Speichern des Formulars fehlgeschlagen. Bitte versuchen Sie es erneut.',
    projectOutdatedAlert: 'Das Projekt wurde seit dem letzten Laden von {lastSavedBy} am {updatedAt} aktualisiert. Möchten Sie die Seite neu laden, um die neuesten Änderungen zu sehen? Ihre ungespeicherten Änderungen gehen dabei verloren.',
    formSavingFailedUnauthorizedAlert: 'Das Speichern des Formulars ist fehlgeschlagen, da Sie keine Berechtigung zum Bearbeiten dieses Projekts mehr haben.',
    abort: 'Abbrechen',
    sourceLanguage: 'Quellsprache',
    targetLanguage: 'Zielsprache',
    language: 'Sprache',
    exportLanguage: 'Sprache exportieren',
    importLanguage: 'Sprache importieren',
    uploadTranslationFile: 'Übersetzungsdatei hochladen',
    languageExportHint: 'Export als PO Datei zum Übersetzen in einem Übersetzungstool.',
    languageImportHint: 'Importieren Sie die übersetzte PO Datei, um die Übersetzungen in das vForm zu übernehmen. Die bestehenden Übersetzungen werden überschrieben. Das Formular wird nicht automatisch gespeichert, sodass Sie das Ergebnis vor dem Speichern überprüfen können.',
    languageImportCompleted: 'Die Sprache wurde importiert, mögliche bestehende Übersetzungen wurden überschrieben. Bitte prüfen Sie die Übersetzungen im vForm und speichern Sie nur, wenn der Import korrekt erfolgt ist. Ansonste laden Sie die Seite neu.',
    progressTracker: 'Fortschrittsanzeige',
    restart: 'Neu starten',
    addAnotherFile: 'Weitere Datei hinzufügen',
    originalText: 'Originaltext',
    translatedText: 'Übersetzter Text',
    configureBottomBar: 'Konfiguriere die untere Leiste',
}